import React from "react";
import CounterComponent from "../Components/Counter/CounterComponent";
import FormComponent from "../Components/Form/FormComponent";

function App() {
  return (
    <div>
      <CounterComponent />
      <FormComponent />
    </div>
  );
}

export default App;
